import { type PropsWithChildren, useRef } from "react";

import Context from "./context";
import createStore, { type FundPageStore } from "./storeCreator";
import type { StoreState } from "./types";

type Props = {
	initialState?: Partial<StoreState>;
	tenant?: string;
};

export default function StoreProvider({
	children,
	initialState,
}: PropsWithChildren<Props>) {
	const store = useRef<FundPageStore>(null);

	if (!store.current) {
		store.current = createStore(initialState);
	} else {
		setTimeout(() => {
			!!store.current && store.current.setState(() => initialState);
		});
	}

	return <Context value={store.current}>{children}</Context>;
}
